<template>
  <v-container fluid class="dashboard-enlace">
    <v-row>
      <v-col cols="12">
        <div class="glass-card">
          <v-card class="transparent" height="100%" elevation="0">
            <v-card-title class="font-weight-bold justify-center">
              <v-icon left color="secondary" size="28">mdi-chart-bar</v-icon>
              <span class="text-h6">Gráfica de vigencias de elementos activos</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <apexchart ref="apex" height="350" type="bar" :options="options2" :series="series2"></apexchart>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <div class="glass-card card-full-height">
          <v-card class="transparent" height="100%" elevation="0">
            <v-card-title class="subtitle-1 font-weight-bold">
              <v-icon left color="secondary" size="20">mdi-account-clock</v-icon>
              Aspirantes listos para turnar a C3
            </v-card-title>
            <v-card-text>
              <div v-if="aspirantesNoTurnados.length == 0" class="text-body-2 text-center py-8 text--secondary">
                <v-icon size="48" color="secondary" class="mb-2">mdi-information-outline</v-icon>
                <div>No hay información para mostrar.</div>
              </div>
              <template v-else>
                <v-list class="transparent py-0">
                  <v-virtual-scroll height="480" item-height="90" :items="aspirantesNoTurnados">
                    <template v-slot:default="{ item }">
                      <v-hover v-slot="{ hover }">
                        <v-list-item
                          :key="item.idPersonal"
                          two-line
                          class="list-item-modern"
                          :class="{ 'list-item-hover': hover }"
                        >
                          <v-list-item-avatar size="56">
                            <v-avatar color="secondary" size="56" class="avatar-modern">
                              <v-icon color="primary" size="28">mdi-account</v-icon>
                            </v-avatar>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 font-weight-bold mb-1">
                              {{ getFullName(item) }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-body-2">{{
                              getAge(item.fechaNacimiento)
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              icon
                              small
                              @click="openTurnaAspiranteDialog(item)"
                              class="btn-action-modern"
                              :class="{ 'btn-action-hover': hover }"
                            >
                              <v-icon color="secondary">mdi-update</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-hover>
                    </template>
                  </v-virtual-scroll>
                </v-list>
              </template>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="glass-card card-full-height">
          <v-card class="transparent" height="100%" elevation="0">
            <v-card-title class="subtitle-1 font-weight-bold">
              <v-icon left color="secondary" size="20">mdi-clock-alert</v-icon>
              Aspirantes en espera de resultados
            </v-card-title>
            <v-card-text>
              <div v-if="aspirantesTurnados.length == 0" class="text-body-2 text-center py-8 text--secondary">
                <v-icon size="48" color="secondary" class="mb-2">mdi-information-outline</v-icon>
                <div>No hay información para mostrar.</div>
              </div>
              <template v-else>
                <v-list class="transparent py-0">
                  <v-virtual-scroll height="480" item-height="110" :items="aspirantesTurnados">
                    <template v-slot:default="{ item }">
                      <v-hover v-slot="{ hover }">
                        <v-list-item
                          :key="item.idPersonal"
                          three-line
                          class="list-item-modern"
                          :class="{ 'list-item-hover': hover }"
                        >
                          <v-list-item-avatar size="56">
                            <v-avatar color="secondary" size="56" class="avatar-modern">
                              <v-icon color="primary" size="28">mdi-account</v-icon>
                            </v-avatar>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 font-weight-bold mb-1">
                              {{ getFullName(item) }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-body-2">{{
                              getAge(item.fechaNacimiento)
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle class="text-body-2">
                              <v-chip x-small color="secondary" class="mt-1"
                                >Resultado C3: {{ item.observacionesC3 }}</v-chip
                              >
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              icon
                              small
                              @click="openResultadoDialog(item)"
                              class="btn-action-modern"
                              :class="{ 'btn-action-hover': hover }"
                            >
                              <v-icon color="secondary">mdi-file-edit</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-hover>
                    </template>
                  </v-virtual-scroll>
                </v-list>
              </template>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="glass-card card-full-height">
          <v-card class="transparent" height="100%" elevation="0">
            <v-card-title class="subtitle-1 font-weight-bold">
              <v-icon left color="secondary" size="20">mdi-certificate</v-icon>
              Personal sorteado para Certificación
            </v-card-title>
            <v-card-text>
              <v-list class="transparent py-0">
                <v-virtual-scroll height="380" item-height="75" :items="personalSorteado">
                  <template v-slot:default="{ item, index }">
                    <v-hover v-slot="{ hover }">
                      <div>
                        <v-list-item class="list-item-modern" :class="{ 'list-item-hover': hover }">
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 font-weight-bold">
                              {{ item.nombre }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-caption">
                              <v-chip x-small color="secondary" label>CUIP: {{ item.cuip }}</v-chip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider v-if="index < personalSorteado.length - 1" class="divider-modern"></v-divider>
                      </div>
                    </v-hover>
                  </template>
                </v-virtual-scroll>
              </v-list>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="glass-card card-full-height">
          <v-card class="transparent" height="100%" elevation="0">
            <v-card-title class="subtitle-1 font-weight-bold">
              <v-icon left color="secondary" size="20">mdi-calendar-clock</v-icon>
              Recordatorio mensual de vigencias
            </v-card-title>
            <v-card-text>
              <div v-if="personalVigencia.length == 0" class="text-body-2 text-center py-8 text--secondary">
                <v-icon size="48" color="secondary" class="mb-2">mdi-information-outline</v-icon>
                <div>No hay información para mostrar.</div>
              </div>
              <template v-else>
                <v-list class="transparent py-0">
                  <v-virtual-scroll height="480" item-height="130" :items="personalVigencia">
                    <template v-slot:default="{ item }">
                      <v-hover v-slot="{ hover }">
                        <v-list-item
                          :key="item.idPersonal"
                          three-line
                          class="list-item-modern"
                          :class="{ 'list-item-hover': hover }"
                        >
                          <v-list-item-avatar size="56">
                            <v-img v-if="item.foto != ''" :src="item.foto" class="avatar-modern"></v-img>
                            <v-avatar color="secondary" size="56" v-else class="avatar-modern">
                              <v-icon color="primary" size="28">mdi-account</v-icon>
                            </v-avatar>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text-body-1 font-weight-bold mb-1">
                              {{ getFullName(item) }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-body-2">
                              {{ item.CatPuestoDependencia.catPuesto.puesto }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle class="text-caption">{{ item.CatArea.title }}</v-list-item-subtitle>
                            <v-list-item-subtitle class="text-caption mt-1">
                              <v-chip x-small color="warning" dark>
                                <v-icon x-small left>mdi-clock-alert</v-icon>
                                Vigencia C3: {{ item.examenC3Mes }} del {{ item.vigenciaAnio }}
                              </v-chip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-hover>
                    </template>
                  </v-virtual-scroll>
                </v-list>
              </template>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <turna-aspirante-dialog-component
      :active="turnaAspiranteDialog"
      :aspirante="selectedAspirante"
      @close="turnaAspiranteDialog = false"
    ></turna-aspirante-dialog-component>
    <registro-resultados-aspirante-dialog-component
      :active="resultadosDialog"
      :personal="selectedPersonal"
      @close="resultadosDialog = false"
    ></registro-resultados-aspirante-dialog-component>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import validator from 'validator'
import ActualizaAspiranteDialogComponent from '../../components/profesionalizacion/ActualizaAspiranteDialogComponent.vue'
import TurnaAspiranteDialogComponent from '../../components/enlace/TurnaAspiranteDialogComponent.vue'
import RegistroResultadosAspiranteDialogComponent from '../../components/enlace/RegistroResultadosAspiranteDialogComponent'

export default {
  components: {
    ActualizaAspiranteDialogComponent,
    TurnaAspiranteDialogComponent,
    RegistroResultadosAspiranteDialogComponent,
  },

  async mounted() {
    this.setData()
  },

  data() {
    return {
      calendario: '',

      selectedOpen: false,
      selectedEvent: {},
      selectedElement: null,

      selectedAspirante: null,
      selectedPersonal: null,
      turnaAspiranteDialog: false,
      resultadosDialog: false,

      options2: {
        chart: {
          type: 'bar',
          background: 'transparent',
          foreColor: '#e0e0e0',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            distributed: false,
            columnWidth: '60%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
          ],
          labels: {
            style: {
              colors: '#e0e0e0',
              fontSize: '12px',
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: '#e0e0e0',
            },
          },
        },
        grid: {
          borderColor: 'rgba(255, 255, 255, 0.1)',
          strokeDashArray: 4,
        },
        theme: {
          mode: 'dark',
          palette: 'palette1',
        },
        colors: ['#F7B731'],
        tooltip: {
          theme: 'dark',
          style: {
            fontSize: '12px',
          },
        },
      },

      series2: [
        {
          type: 'column',
          data: [],
          name: 'Cantidad de elementos',
        },
      ],
      personalSorteado: [
        { nombre: 'Ernesto Martinez Calderon', cuip: 'MACE891030HMSRLR0912' },
        { nombre: 'Ana López Pérez', cuip: 'LOPA900101MDFRZN01' },
        { nombre: 'Carlos Ruiz Gómez', cuip: 'RUIG850505HDFRRL02' },
        { nombre: 'María Fernanda Torres', cuip: 'TORF920202MDFRRL03' },
        { nombre: 'Luis Alberto Sánchez', cuip: 'SALA880808HDFRRL04' },
      ],
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirantes: 'getPreaspirantes',
      aspirantes: 'getAspirantes',
    }),

    ...mapGetters('personal', {
      personal: 'getPersonal',
    }),

    aspirantesNoTurnados() {
      return this.aspirantes.filter((aspirante) => {
        return aspirante.observacionesC3 === ''
      })
    },

    aspirantesTurnados() {
      return this.aspirantes.filter((aspirante) => {
        return aspirante.observacionesC3 === 'NO REGISTRADO'
      })
    },

    personalVigencia() {
      return this.personal.filter((personal) => {
        return this.getVigenciaProgramada(personal.examenC3Mes, personal.vigenciaAnio) == moment().format('YYYY-MM')
      })
    },
  },

  methods: {
    mostrarEvento(event) {
      this.selectedEvent = event.event
      this.selectedOpen = true
    },

    closeMenu() {
      this.selectedOpen = false
    },

    openTurnaAspiranteDialog(aspirante) {
      this.selectedAspirante = aspirante
      this.turnaAspiranteDialog = true
    },

    openResultadoDialog(personal) {
      this.selectedPersonal = personal
      this.resultadosDialog = true
    },

    getVigenciaProgramada(mes, anio) {
      var mesC3 = moment().month(mes).locale('es').format('M')

      var fecha = anio.toString() + '-' + mesC3.toString()

      return moment(fecha).subtract(7, 'months').format('YYYY-MM')
    },

    setData() {
      this.$refs.apex.updateSeries([{ type: 'column', data: this.getVigenciaMensual(), name: 'Cantidad de elementos' }])
    },

    getVigenciaMensual() {
      var vigencia = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      this.personal.forEach((personal) => {
        if (personal.examenC3Mes != '') {
          switch (moment().month(personal.examenC3Mes).locale('es').format('M')) {
            case '1':
              vigencia[0]++
              break
            case '2':
              vigencia[1]++
              break
            case '3':
              vigencia[2]++
              break
            case '4':
              vigencia[3]++
              break
            case '5':
              vigencia[4]++
              break
            case '6':
              vigencia[5]++
              break
            case '7':
              vigencia[6]++
              break
            case '8':
              vigencia[7]++
              break
            case '9':
              vigencia[8]++
              break
            case '10':
              vigencia[9]++
              break
            case '11':
              vigencia[10]++
              break
            case '12':
              vigencia[11]++
              break
            default:
              break
          }
        }
      })

      return vigencia
    },
  },
}
</script>
<style scoped>
/* ===========================
   DASHBOARD ENLACE C3 - ESTILOS MODERNOS
   =========================== */
.dashboard-enlace {
  background: transparent;
}

/* Glass-morphism card effect */
.glass-card {
  background: rgba(30, 30, 30, 0.6) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(247, 183, 49, 0.1);
  border-radius: 16px;
  padding: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.glass-card:hover {
  border-color: rgba(247, 183, 49, 0.3);
  box-shadow: 0 8px 32px rgba(247, 183, 49, 0.15);
  transform: translateY(-2px);
}

.card-full-height {
  height: 100%;
}

/* ===========================
   LIST ITEMS MODERNOS
   =========================== */
.list-item-modern {
  border-radius: 12px;
  margin: 8px 0;
  padding: 12px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.03);
}

.list-item-hover {
  background: rgba(247, 183, 49, 0.1) !important;
  transform: translateX(4px);
}

/* Avatar moderno con efecto glass */
.avatar-modern {
  background: rgba(247, 183, 49, 0.15) !important;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(247, 183, 49, 0.3);
  transition: all 0.3s ease;
}

.list-item-hover .avatar-modern {
  border-color: #f7b731;
  box-shadow: 0 0 20px rgba(247, 183, 49, 0.4);
}

/* ===========================
   BOTONES DE ACCIÓN
   =========================== */
.btn-action-modern {
  background: rgba(247, 183, 49, 0.1) !important;
  transition: all 0.3s ease;
}

.btn-action-hover {
  background: rgba(247, 183, 49, 0.2) !important;
  transform: scale(1.1);
}

/* ===========================
   DIVIDERS
   =========================== */
.divider-modern {
  border-color: rgba(255, 255, 255, 0.05) !important;
  margin: 0 16px;
}

/* ===========================
   CARD TITLES CON ICONOS
   =========================== */
::v-deep .v-card__title {
  color: #e0e0e0 !important;
  padding: 20px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

::v-deep .v-card__title .v-icon {
  margin-right: 8px;
}

/* ===========================
   VIRTUAL SCROLL STYLING
   =========================== */
::v-deep .v-virtual-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(247, 183, 49, 0.3) rgba(255, 255, 255, 0.05);
}

::v-deep .v-virtual-scroll::-webkit-scrollbar {
  width: 6px;
}

::v-deep .v-virtual-scroll::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
}

::v-deep .v-virtual-scroll::-webkit-scrollbar-thumb {
  background: rgba(247, 183, 49, 0.3);
  border-radius: 10px;
}

::v-deep .v-virtual-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(247, 183, 49, 0.5);
}

/* ===========================
   CHIPS MODERNOS
   =========================== */
::v-deep .v-chip.secondary {
  background: rgba(247, 183, 49, 0.15) !important;
  color: #f7b731 !important;
  font-weight: 600;
  border: 1px solid rgba(247, 183, 49, 0.3);
}

::v-deep .v-chip.warning {
  background: rgba(255, 159, 67, 0.15) !important;
  border: 1px solid rgba(255, 159, 67, 0.3);
}

/* ===========================
   LIST STYLING
   =========================== */
::v-deep .v-list-item__title {
  color: #e0e0e0 !important;
  line-height: 1.4;
}

::v-deep .v-list-item__subtitle {
  color: rgba(255, 255, 255, 0.6) !important;
  line-height: 1.3;
}

/* ===========================
   APEXCHARTS DARK THEME OVERRIDE
   =========================== */
::v-deep .apexcharts-canvas {
  background: transparent !important;
}

::v-deep .apexcharts-tooltip {
  background: rgba(30, 30, 30, 0.95) !important;
  border: 1px solid rgba(247, 183, 49, 0.3) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
}

::v-deep .apexcharts-tooltip-title {
  background: rgba(247, 183, 49, 0.15) !important;
  border-bottom: 1px solid rgba(247, 183, 49, 0.3) !important;
  color: #f7b731 !important;
}

/* ===========================
   RESPONSIVE ADJUSTMENTS
   =========================== */
@media (max-width: 1264px) {
  .glass-card {
    margin-bottom: 16px;
  }
}

@media (max-width: 960px) {
  ::v-deep .v-virtual-scroll {
    height: 300px !important;
  }
}
</style>
